import HTTPService from '../HTTPService'

class Tag {
  getAll (companySlug) {
    return HTTPService.get(`company/${companySlug}/tag`)
  }

  getOne (companySlug, tagSlug) {
    return HTTPService.get(`company/${companySlug}/tag/${tagSlug}`)
  }
}

export default new Tag()
